'use client'

export { Tooltip } from 'react-tooltip'
